module.exports = __webpack_public_path__ + "static/media/av6.0c80de3f.JPG";